export default __webpack_public_path__ + "files/usgs_calculations-fb00a3a9a2b789c99a91415ca321f628.png";